import { Link } from "react-router-dom";

/**
 * "You don't hide a thing. You hide *in* a place." The last two letters drop
 * into a map pin, so the wordmark says the mechanic out loud.
 *
 * Brand kit rules honoured here: always lowercase, the pin is always Flare
 * (never amber, cyan or green — those mean things in the game), no outline,
 * no shadow, no tilt.
 */
export function Wordmark({
  size = 22,
  onDusk = false,
  drop = false,
  asLink = true,
}: {
  size?: number;
  /** Inverts the "hide" to white for placement on the Dusk surface. */
  onDusk?: boolean;
  /** Play the pin-drop animation once on mount. */
  drop?: boolean;
  asLink?: boolean;
}) {
  const mark = (
    <span
      className="wordmark"
      style={{ fontSize: size, color: onDusk ? "#fff" : "var(--dusk)" }}
    >
      hide
      <span className={`pin${drop ? " drop" : ""}`}>in</span>
    </span>
  );

  if (!asLink) return mark;
  return (
    <Link to="/" aria-label="Hidein — home" style={{ textDecoration: "none" }}>
      {mark}
    </Link>
  );
}

/** The pin alone. Used below the 88px wordmark minimum, and as the app icon. */
export function PinMark({ size = 32 }: { size?: number }) {
  return (
    <span className="wordmark" style={{ fontSize: size }}>
      <span className="pin">in</span>
    </span>
  );
}
